import { useEffect, useState } from "react";
const getLocalStorageValue = (key, initValue) => {
  const savedValue = JSON.parse(localStorage.getItem(key));
  return savedValue || initValue;
};

export const useLocalStorage = (key, initValue) => {
  const [value, setValue] = useState(() =>
    getLocalStorageValue(key, initValue)
  );

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};
